export default __webpack_public_path__ + "static/media/behance.825f52eb.svg";